import React from 'react';
import BookTreeComponent from './BookTree';
import { range } from 'lodash';
// import { debounce } from 'lodash';
import { TreeInfo } from './Utils';


type Props = {
  data: TreeInfo,
  set_id: (new_id: string) => void,
  data_id: string,
};
type State = {
  qa_idx: number,
};

class NarrativeQABookTree extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      qa_idx: 0,
    };
  }

  componentDidUpdate(prevProps: Props) {
    /*
    if (this.props.all_data.id !== prevProps.all_data.id) {
      console.log('Data changed!');
      const relevant_keys = get_relevant_keys(this.props.all_data, null);
      const newState: State = {
        ...
      } as State;
      this.setState(newState as any)
    }
     */
  }

  updateState(update: any) {
    this.setState(update);
    console.log('update', update);
  }

  handleStateChange(key: string, event: any) { // KeyboardEvent
    const update: any = {};
    update[key] = event.target.value;
    this.updateState(update);
  }

  showError(err: any) {
    // TODO: better
    console.error(err);
    alert(err);
  }
  render() {
    let [model, numeric_id_str] = this.props.data_id.split("/");
    let numeric_id = parseInt(numeric_id_str)+1;
    const qa_info = this.props.data.preds[this.state.qa_idx];
    const num_qs = this.props.data.preds.length;
    console.log("QA", qa_info)
      /*
            Summary model: {" "}
            <select style={{width: '80px'}} value={model}
              onChange={(ev) => {
                this.props.set_id([ev.target.value, numeric_id_str].join("/"))
              }}
            >
              <option value="175b">175B</option>
              <option value="175bfirsttree">175B (trained on first subtree only)</option>
              <option value="6b">6B</option>
            </select>
            <br/>
      */

    return (
      <div>
        <div className="flex-container">
          <div>
            Document
            <select
              value={numeric_id}
              onChange={(ev) => {
                let new_id: number = parseInt(ev.target.value) - 1;
                if (isNaN(new_id)) { return; }
                console.log("setting", new_id.toString())
                this.props.set_id([model, new_id.toString()].join("/"))
              }}
            >
              {
                range(1, 356).map((id) => {
                  return <option key={id} value={id}>{id}</option>
                })
              }
            </select>{" of 355"}
            <br/>
            <h3> {this.props.data.info.wiki_title} </h3>
            <a href={this.props.data.info.story_url}>Source</a>
            <br/>
            <br/>
            <h4>Question {this.state.qa_idx + 1}</h4> {qa_info.qa.question}
            <br/>
            <br/>
            <button onClick={() => this.setState({qa_idx: (this.state.qa_idx - 1 + num_qs) % num_qs})}>
                Previous question
            </button>
            <button onClick={() => this.setState({qa_idx: (this.state.qa_idx + 1) % num_qs})}>
              Next question
            </button>
            <br/>
            <br/>
          </div>

          <div style={{paddingLeft: '25px'}}>
            <h4>Answers table</h4>
            <table> <tbody>
              <tr>
                <td><b style={{float: 'right'}}>(answerer)</b></td>
                <td colSpan={2}><b>Human</b></td>
                <td colSpan={4}><b>Model (UnifiedQA)</b></td>
              </tr>
              <tr>
                <td><i>(input source){" "}</i></td>
                <td><b>1</b></td>
                <td><b>2</b></td>
                <td><b>3b</b></td>
                <td><b>large</b></td>
                <td><b>base</b></td>
                <td><b>small</b></td>
              </tr>
              <tr>
                <td><i>Wikipedia</i>{" "}
                  <a href={this.props.data.info.wiki_url}>(link)</a>
                </td>
                <td>{qa_info.qa.answer1}</td>
                <td>{qa_info.qa.answer2}</td>
                <td>{qa_info.preds['unifiedqa3b_wiki']}</td>
                <td>{qa_info.preds['unifiedqalarge_wiki']}</td>
                <td>{qa_info.preds['unifiedqabase_wiki']}</td>
                <td>{qa_info.preds['unifiedqasmall_wiki']}</td>
              </tr>
              <tr>
                <td>
                <i>175B depth 1</i>
                </td>
                <td></td>
                <td></td>
                <td>{qa_info.preds['unifiedqa3b_level_1']}</td>
                <td>{qa_info.preds['unifiedqalarge_level_1']}</td>
                <td>{qa_info.preds['unifiedqabase_level_1']}</td>
                <td>{qa_info.preds['unifiedqasmall_level_1']}</td>
              </tr>
              <tr>
                <td>
                  <i>175b depth 0</i>
                </td>
                <td></td>
                <td></td>
                <td>{qa_info.preds['unifiedqa3b_level_0']}</td>
                <td>{qa_info.preds['unifiedqalarge_level_0']}</td>
                <td>{qa_info.preds['unifiedqabase_level_0']}</td>
                <td>{qa_info.preds['unifiedqasmall_level_0']}</td>
              </tr>
              <tr>
                <td><i>Empty</i></td>
                <td></td>
                <td></td>
                <td>{qa_info.preds['unifiedqa3b_empty']}</td>
                <td>{qa_info.preds['unifiedqalarge_empty']}</td>
                <td>{qa_info.preds['unifiedqabase_empty']}</td>
                <td>{qa_info.preds['unifiedqasmall_empty']}</td>
              </tr>
            </tbody> </table>
            <br/>

          </div>

          <br/>
        </div>
        <BookTreeComponent data={this.props.data} is_gutenberg={this.props.data.info.kind === 'gutenberg'}/>
      </div>
    );
  }
}

export default NarrativeQABookTree;

